import {getEventObj} from "../atBrowserUtils"

class TableCell {
    constructor(value, rowObj)
    {
        this.value = value;
        this.colIdx = -1;
        this.rowObj = rowObj;
        this.renderer = null;
        this.cellElem = document.createElement("td");
        this.cellElem.cellObj = this;
    }

    getRow()
    {
        return this.rowObj;
    }

    setColspan(colspan)
    {
        return this.colspan = colspan;
    }

    setRow(rowObj)
    {
        this.rowObj = rowObj;
    }

    setColIdx(colIdx)
    {
        this.colIdx = colIdx;
    }

    getColIdx()
    {
        return this.colIdx;
    }

    getCellEl()
    {
        return this.cellElem;
    }

    setRenderer(renderer)
    {
        this.renderer = renderer;
    }

    getRenderer()
    {
        return this.renderer;
    }

    updateUI()
    {
        this.renderer.updateUI(this);
    }

    writeContent()
    {
        this.renderer.writeContent(this);
    }

    // use, when you need to update cell content and cell UI with new data (see UsersForTTApproverCellRenderer, AssignTTApproversCellRenderer, for example)
    updateCell()
    {
        this.renderer.updateContent(this);
        this.updateUI();
    }

    getValue()
    {
        return this.value;
    }

    setValue(value)
    {
        this.value = value;
    }

    isFirst()
    {
        return this.colIdx === 0;
    }

    isLast()
    {
        return this.colIdx === this.getRow().getCells().length - 1;
    }

    getTable()
    {
        return this.getRow().getTable();
    }

    leftCell()
    {
        let leftIndex = this.getColIdx() - 1;
        if (leftIndex >= 0)
            return this.getRow().getCell(leftIndex);
    }

    upperCell()
    {
        let upperRowIndex = this.getRow().getRowIdx() - 1;
        if (upperRowIndex >= 0)
            return this.getRow().getTable().getCell(upperRowIndex, this.getColIdx());
    }

    getMouseHandler()
    {
        return this.getRow().getTable().getMouseEventsHandler();
    }

    mouseOver(evt) { return this.getMouseHandler().mouseOver(evt, this); }

    mouseOut(evt) { return this.getMouseHandler().mouseOut(evt, this); }

    mouseDown(evt) { return this.getMouseHandler().mouseDown(evt, this); }

    mouseUp(evt) { return this.getMouseHandler().mouseUp(evt, this); }

    mouseMove(evt) { return this.getMouseHandler().mouseMove(evt, this); }

    contextMenu(evt) { return this.getMouseHandler().contextMenu(evt, this); }

    setupMouseHandlers()
    {
        this.cellElem.onmouseover = function(evt) { this.cellObj.mouseOver(getEventObj(evt)); };
        this.cellElem.onmouseout = function(evt) { this.cellObj.mouseOut(getEventObj(evt)); };
        this.cellElem.onmousedown = function(evt) { this.cellObj.mouseDown(getEventObj(evt)); };
        this.cellElem.onmouseup = function(evt) { this.cellObj.mouseUp(getEventObj(evt)); };
        this.cellElem.onmousemove = function(evt) { this.cellObj.mouseMove(getEventObj(evt)); };
        this.cellElem.oncontextmenu = function(evt) { this.cellObj.contextMenu(getEventObj(evt));};
    }
}

export default TableCell



// WEBPACK FOOTER //
// ./web/js/table/TableCell.js